/**
 * ==============================
 *  JavaScript
 * ==============================
 *      Import all scripts into
 *      this file
 * 
 */

// Swiper
require('./swiper');

require('./navigation');